import { ArrowDownLeft, ArrowUpRight, FileText, Layers, CalendarDays } from 'lucide-react';

const DEFAULT_ACTIONS = [
  { id: 'deposit', label: 'Deposit', icon: ArrowDownLeft, tone: 'success' },
  { id: 'withdraw', label: 'Withdraw', icon: ArrowUpRight, tone: 'primary' },
  { id: 'plans', label: 'ETF Plans', icon: Layers, tone: 'orange' },
  { id: 'calendar', label: 'Calendar', icon: CalendarDays, tone: 'blue' },
  { id: 'statement', label: 'Statement', icon: FileText, tone: 'slate' },
];

const toneClasses = {
  success: 'bg-brand-success/10 text-brand-success',
  primary: 'bg-brand-primary/10 text-brand-primary',
  orange: 'bg-orange-50 text-orange-600',
  blue: 'bg-sky-50 text-sky-600',
  violet: 'bg-violet-50 text-violet-600',
  slate: 'bg-slate-100 text-slate-700',
};

export const QuickActionGrid = ({ onAction, actions = DEFAULT_ACTIONS }) => {
  return (
    <div
      className="grid grid-cols-3 sm:grid-cols-6 gap-3"
      data-testid="quick-action-grid"
    >
      {actions.map((a) => {
        const Icon = a.icon;
        return (
          <button
            key={a.id}
            onClick={() => onAction?.(a.id)}
            className="flex flex-col items-center gap-2 py-3 px-2 rounded-xl bg-white border border-brand-border hover:border-brand-primary hover:shadow-sm transition-all active:scale-95 group"
            data-testid={`quick-action-${a.id}`}
          >
            <div className={`w-11 h-11 rounded-full flex items-center justify-center ${toneClasses[a.tone] || toneClasses.slate} group-hover:scale-105 transition-transform`}>
              <Icon size={18} />
            </div>
            <span className="text-[11px] font-semibold text-brand-text-primary">{a.label}</span>
          </button>
        );
      })}
    </div>
  );
};
